"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _tokens = require("@superlogica/foundation/tokens");

var _styledComponents = require("styled-components");

var Modal = function Modal(_ref) {
  var children = _ref.children,
      isOpen = _ref.isOpen,
      label = _ref.label,
      onRequestClose = _ref.onRequestClose,
      parent = _ref.parent,
      width = _ref.width,
      theme = _ref.theme,
      top = _ref.top;

  _reactModal.default.setAppElement("#".concat(parent));

  var baseConfig = {
    content: {
      top: top ? top : '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      padding: 0,
      border: 'none',
      background: _tokens.colors[theme.colors.neutral0.color + theme.colors.neutral0.scale],
      borderRadius: 0,
      transform: 'translate(-50%, -50%)',
      width: '100%',
      maxWidth: width || 600,
      overflow: 'initial'
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.6)'
    }
  };
  return /*#__PURE__*/_react.default.createElement(_reactModal.default, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    style: baseConfig,
    contentLabel: label,
    ariaHideApp: false,
    "aria-labelledby": label
  }, children);
};

Modal.defaultProps = {
  parent: 'root'
};

var _default = (0, _styledComponents.withTheme)(Modal);

exports.default = _default;